import { Component, OnInit } from '@angular/core';
import { UtilService, VariablesService } from '../../../../shared/services';

@Component({
  selector: 'app-sip-impact',
  templateUrl: './sip-impact.component.html',
  styleUrls: ['./sip-impact.component.scss']
})
export class SipImpactComponent implements OnInit {

  constructor(
    private util: UtilService,
    private vars: VariablesService
  ) { }

  info = {
    title: 'Our Impact',
    subTitle: {
      desktop: {
        msg: '“I was powerless against my daughter\'s cancer & I could not afford treatment. When I found out that kind strangers donated Rs 31 lakh for her life-saving transplant, I cried tears of relief. Without them, I would have lost Zoya."',
        by: ' - Shanu (Mother of 5-year-old Zoya)'
      },
      mobile: {
        msg: '“I watched my daughter suffer from cancer & was powerless to help because I could not afford treatment. So when I found out that kind strangers donated Rs 31 lakh for her life-saving transplant, I cried tears of relief. Without their help, I would not have my Zoya here with me."',
        by: ' - Shanu (Mother of 5-year-old Zoya)'
      }
    }
  };

  contributionInfo = [
    { id: 1, number: '50,349', text: 'members donating monthly', imgName: 'users' },
    { id: 2, number: '670+', text: 'children have been saved', imgName: 'family' },
    { id: 3, number: '₹25 million+', text: 'raised for patients', imgName: 'money' },
    { id: 4, number: '540', text: 'life-changing treatments funded', imgName: 'medicine' },
  ];

  locationProfileInfo = [
    { id: 1, name: 'durga', desc: '1760+ Donors Raised ₹20,00,000 for Durga\'s Cancer Treatment', isSelected: true },
    { id: 2, name: 'anuj', desc: '124+ Donors Raised ₹2,50,000 for Anuj\'s Chemotherapy', isSelected: false },
    { id: 3, name: 'asha', desc: '240+ Donors Raised ₹3,75,000 for Asha\'s Surgery', isSelected: false },
    { id: 4, name: 'aashiya', desc: '441+ Donors Raised ₹8,00,000 for Aashiya\'s Cochlear Implant', isSelected: false },
    { id: 5, name: 'mahi', desc: '425+ Donors Raised ₹7,50,000 for Mahi\'s Lung Surgery', isSelected: false },
    { id: 6, name: 'samanyu', desc: ' 2760+ Donors Raised ₹30,00,000 for Samanyu\'s Cancer Treatment', isSelected: false },
    { id: 7, name: 'vydika', desc: '380+ Donors Raised ₹5,75,000 for Vydika\'s Heart Surgery', isSelected: false },
    { id: 8, name: 'chethan', desc: '566+ Donors Raised ₹7,00,000 for Chethan\'s Liver Transplant', isSelected: false },
  ];

  isMobile: any;
  subsCount;

  ngOnInit() {
    this.isMobile = this.util.isMobile();
    this.vars.getSubsCount();
    this.vars.subsCount.subscribe((res: any) => {
      const val = parseInt(res?.monthlyDonors, 10).toLocaleString('en-IN').split('.')[0];
      this.contributionInfo[0].number = String(val);
    });
  }

  selectLocationPin(index: number): void {
    this.resetLocationSelection();
    this.locationProfileInfo[index].isSelected = true;
  }

  resetLocationSelection(): void {
    this.locationProfileInfo.forEach(location => {
      if (location.isSelected) {
        location.isSelected = false;
      }
    });
  }

}
